import * as React from 'react';
import { useState } from 'react';
import { loadMoreUGCReviews, setReviewSorting } from '../../../actions/ugcAction';
import { ArrowRightIcon } from '../../../components/Icons/ArrowRightIcon';
import { Modal } from '../../../components/Modal';
import ReviewsDesktop from '../../../components/DesktopReviews/DesktopReviews';
import * as Colors from '../../../consts/variables';
import { getRatingLabel } from '../../../helpers/cruiseSearchHelper';
import { normalizeLabels } from '../../../helpers/labels';
import { __ } from '../../../helpers/TranslationService';
import { ICruiseReducer } from '../../../interfaces';
import { IUGCReviewsReducer } from '../../../interfaces/IUGCReviews';
import { IPageDataReducer } from '../../../reducers/pageData';
import { LabelBox } from '../../../components/LabelBox/LabelBox';
import { Rating } from '../../Search/components/Rating';

const styles: Record<string, React.CSSProperties> = {
    wrapper: {
        backgroundColor: '#f0f0f0',
        padding: '20px 10px',
    },
    labelsWrapper: {
        listStyle: 'none',
        display: 'flex',
        margin: '5px 0px 8px',
        overflow: 'hidden',
        maxWidth: '100%',
        flexWrap: 'wrap',
        maxHeight: '25px',
        flexDirection: 'row',
        justifyContent: 'center',
    },
    title: {
        marginBottom: '10px',
        fontSize: '15px',
        textAlign: 'center',
    },
    noWrap: {
        whiteSpace: 'nowrap',
    },
    labelItemWrapper: {
        marginRight: '3px',
        whiteSpace: 'nowrap',
    },
    ratingWrapper: {
        width: '160px',
        margin: '25px auto',
    },
    allReviewsWrapper: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: Colors.acqa,
        fontWeight: 'bold',
        fontSize: '15px',
        margin: '20px 0 0 0',
        lineHeight: '23px',
    },
    allReviewsIcon: {
        fill: Colors.acqa,
    },
};

interface IProps {
    pageData: IPageDataReducer;
    cruisePage: ICruiseReducer;
    reviewsData: IUGCReviewsReducer;
    loadMoreUGCReviews: typeof loadMoreUGCReviews;
    setReviewSorting: typeof setReviewSorting;
}

export const UserGeneratedContentSection = (props: IProps) => {
    const [modelIsVisible, setModelVisibility] = useState(false);
    const { pageData, cruisePage, reviewsData, loadMoreUGCReviews, setReviewSorting } = props;
    const { ship } = cruisePage;
    const { reviews, isLoading, sortString } = reviewsData;

    const getModal = () => {
        return (
            <Modal isOpen onClose={() => setModelVisibility(false)}>
                <ReviewsDesktop
                    reviews={reviews}
                    offers={cruisePage.offers}
                    priceCurrency={pageData.appConfig.defaultCurrency}
                    loadMoreReviews={loadMoreUGCReviews}
                    setSortString={setReviewSorting}
                    sortString={sortString}
                    filterParams={`filterParams[shipNid]=${ship.nid}`}
                    reviewsType="shipReviews"
                />
            </Modal>
        );
    };
    const reviewsAttributes = reviews.aggregation.data.attributes;
    const normalizedUgcLabels = normalizeLabels({
        ugcLabels: cruisePage.ugcLabels,
        excludeCluster: ['constellation', 'productData'],
    });

    const contentTitle = `${__('Thats what our customers say about the', 'dreamlines')} `;
    const shipTitle = `${cruisePage.ship.title}:`;
    return (
        <div style={styles.wrapper}>
            <div style={styles.title}>
                {contentTitle}
                <span style={styles.noWrap}>{shipTitle}</span>
            </div>
            <ul style={styles.labelsWrapper}>
                {normalizedUgcLabels.map((textLabel) => (
                    <li style={styles.labelItemWrapper} key={textLabel.label}>
                        <LabelBox
                            type={textLabel.label}
                            label={__(textLabel.label, 'dreamlines')}
                        />
                    </li>
                ))}
            </ul>
            <div style={styles.ratingWrapper}>
                <Rating
                    value={reviewsAttributes.overall}
                    string={getRatingLabel(reviewsAttributes.overall)}
                    amount={reviewsAttributes.numRatings}
                />
            </div>
            <div style={styles.allReviewsWrapper} onClick={() => setModelVisibility(true)}>
                <span>{__('All Reviews', 'dreamlines')}</span>
                <ArrowRightIcon style={styles.allReviewsIcon} height={15} />
            </div>
            {modelIsVisible && getModal()}
        </div>
    );
};
